import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';
import { TransactionDetail } from '@/pages/DocumentsWeb/DocumentsType';

type GetDocumentsWebResponse = {
  value: TransactionDetail[];
};

type QueryType = {
  fechaDesde: Date | null;
  fechaHasta: Date | null;
};

export const getDocumentsWeb = async (
  query: QueryType
): Promise<TransactionDetail[]> => {
  try {
    const res = await apiClient.post<GetDocumentsWebResponse>(
      Endpoints.DocumentsWeb,
      query
    );
    return res.data.value || [];
  } catch (error) {
    if (isAxiosError(error) && error.response) {
      if (error.response.status === 404) {
        throw new Error('Invalid Data');
      } else {
        throw new Error(error.message);
      }
    } else {
      throw error;
    }
  }
};
